import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkToc from "remark-toc";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import "github-markdown-css";
import "./MarkdownRenderer.css";

const MarkdownHeading = ({ level, children }) => {
  const flatten = (text, child) => {
    return typeof child === "string"
      ? text + child
      : React.Children.toArray(child.props.children).reduce(flatten, text);
  };

  const text = React.Children.toArray(children).reduce(flatten, "");
  const slug = text.toLowerCase().replace(/\W/g, "-");

  const HeadingTag = `h${level}`;
  return <HeadingTag id={slug}>{children}</HeadingTag>;
};

const MarkdownRenderer = ({ path }) => {
  const [markdown, setMarkdown] = useState("");

  const getFromFile = (URI) => {
    fetch(URI)
      .then((r) => r.text())
      .then((md) => {
        setMarkdown(md);
      });
  };

  useEffect(() => {
    if (path) {
      getFromFile(path);
    }
  }, [path]);

  return (
    <div className="markdown-body">
      <ReactMarkdown
        children={markdown}
        remarkPlugins={[remarkToc, remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        skipHtml={false}
        components={{
          h1: (props) => <MarkdownHeading level={1} {...props} />,
          h2: (props) => <MarkdownHeading level={2} {...props} />,
          h3: (props) => <MarkdownHeading level={3} {...props} />,
          h4: (props) => <MarkdownHeading level={4} {...props} />,
          h5: (props) => <MarkdownHeading level={5} {...props} />,
          h6: (props) => <MarkdownHeading level={6} {...props} />,
        }}
      />
    </div>
  );
};

export default MarkdownRenderer;
